import { useEffect, useRef } from 'react';
import { applyEmbedDimensions, shouldApplyEmbedSizing } from '../../../utils/embedResize';

export function useEmbedSizing(isOpen) {
  const isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;

  useEffect(() => {
    if (!shouldApplyEmbedSizing()) return;
    applyEmbedDimensions(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (!shouldApplyEmbedSizing()) return;

    let timer = null;
    const onResize = () => {
      // Debounce: parent iframe resize fires resize inside the frame; without
      // this, dimension updates can loop and look like open/close flickering.
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        applyEmbedDimensions(isOpenRef.current);
      }, 100);
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (timer) window.clearTimeout(timer);
    };
  }, []);
}
